module.exports = __webpack_public_path__ + "img/serviceImg.7c732333.png";